import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import "../../../../assets/styles/waitingListLead/WaitingListLeadOverview.scss";
import EmailModal from "./EmailModal";
import NoteModal from "./NoteModal";
import WaitingListLeadStateClosed from "./WaitingListLeadStateClosedV1";
import { WaitingListLeadState } from "../types/enums";
import ApiError from "../../../../lib/ApiError";
import BackToTopButton from "../../../../components/ui/buttons/BackToTopButton";
import WaitingListLeadStateAcquiredV1 from "./WaitingListLeadStateAcquiredV1";
import WaitingListLeadStateOpenV1 from "./WaitingListLeadStateOpenV1";
import WaitingListLeadStateRejectedV1 from "./WaitingListLeadStateRejectedV1";
import WaitingListLeadStateAcquiredWithClosedDateV1 from "./WaitingListLeadStateAcquiredWithClosedDateV1";
import { useSupplierInfo } from "layout/context/SupplierInfoContext";
import { isRegistrationForAm } from "constants/index";
import { getCommaSeparatedPhoneNumberFromArray } from "lib/leadNumber/phoneNumber";
import WaitingListLeadBasicInformationTableV1 from "./WaitingListLeadBasicInformationTableV1";
import WaitingListLeadProductCriteriaInformationTableV1 from "./WaitingListLeadProductCriteriaInformationTableV1";
import GroupSection from "./GroupSection";
import ProductDetailCard from "./ProductDetailCard";
import { ILeadPhoneNumber } from "types";
import CollapsibleGroup from "./CollapsibleGroup";
import CallModal from "./CallModal";
import TaskModal from "./TaskModal";
import SourceModal from "./SourceModal"; // Import der SourceModal
import MiddleSection from "./MiddleSection";
import CrossSellSection from "./CrossSellingSection";

// Definition eines Activity-Interfaces
interface Activity {
  icon: string;
  time: string;
  text: string;
  title?: string;
  detail?: string;
}

const mockData = {
  waitingListLeadDetailsInfo: {
    firstName: "Max",
    lastName: "Mustermann",
    clientAvailability: "Mo-Fr 9-17 Uhr",
    bedarfsort: "Mainz, 55116",
    addresse: "Musterstraße 15, 55116 Mainz",
    phoneNumber: "017621231523",
    phoneNumbers: [
      { type: "mobile", number: "017621231523", internationalNoBlanks: 176826378123 },
    ] as unknown as ILeadPhoneNumber[],
    waitingListLeadState: WaitingListLeadState.Acquired,
    isClosedByClient: false,
    isPersonalProduct: false,
    productName: "Pflegedienst",
    requestRegion: "Mainz",
    requestZipCode: "55116",
    productCriteriaList: [
      { criteriaName: "Pflegegrad/-stufe", value: "3" },
      { criteriaName: "Aufgaben", value: "Grundpflege + Behandlungspflege" },
      { criteriaName: "Betreuungsbedarf – Wöchentlicher Umfang", value: "Täglich" },
      { criteriaName: "Zeitpunkt – Bedarf", value: "Schnellstmöglich" }
    ],
    waitingListLeadNumber: "ANF-001"
  },
  productItems: [
    {
      title: "Pflegedienst",
      detail: "Status: Aktiv",
      onOptionsClick: () => alert("Optionen für Produkt A")
    },
  ],
  relativeItems: [
    {
      title: "Petra Mustermann",
      detail: "Mutter - Primärer Kontakt",
      onOptionsClick: () => alert("Optionen für Mutter")
    },
    {
      title: "Hans Mustermann",
      detail: "Bruder - Sekundärer Kontakt",
      onOptionsClick: () => alert("Optionen für Onkel")
    }
  ],
  tabContent: {
    activities: [
      { icon: "fa-solid fa-circle-check", time: new Date().toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }), text: "Klient jetzt anrufen", detail: "Anruf erfolgreich" },
      { icon: "fa-solid fa-check", time: new Date().toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }), text: "Freie Kapazitäten gemeldet", detail: "Anruf erfolgreich" },
      { icon: "fa-solid fa-star", time: "25.01.2026, 07:00", text: "Anfrage erhalten", detail: "Anruf erfolgreich" },
    ],
    appointments: { title: "Termine", text: "Hier werden alle geplanten Termine angezeigt." },
    contactDetailsTitle: "Kontaktdetails"
  }
};




function WaitingListLeadOverviewV1() {
  const { secureId } = useParams();
  const { isAuthenticated } = useSupplierInfo();
  const [isRegisterForAMSet, setIsRegisterForAMSet] = useState(false);
  const [promotionModal, setPromotionModal] = useState(false);
  const [chatModalOpen, setChatModalOpen] = useState(false);
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [callModalOpen, setCallModalOpen] = useState(false);
  const [taskModalOpen, setTaskModalOpen] = useState(false);
  const [sourceModalOpen, setSourceModalOpen] = useState(false); // Neuer State
  const navigate = useNavigate();

  const [activityLog, setActivityLog] = useState<Activity[]>(mockData.tabContent.activities);
  const [emailActivities, setEmailActivities] = useState<Activity[]>([]);
  const [noteActivities, setNoteActivities] = useState<Activity[]>([]);
  const [callActivities, setCallActivities] = useState<Activity[]>([]);
  const [taskActivities, setTaskActivities] = useState<Activity[]>([]);
  const [selectedEmail, setSelectedEmail] = useState<boolean>(false);

  useEffect(() => {
    const isSet = localStorage.getItem(isRegistrationForAm) !== null;
    setIsRegisterForAMSet(isSet);
  }, [navigate]);

  function getWaitingListLeadStatusView(
    state: WaitingListLeadState,
    isClosedByClient: boolean,
    isPersonalProduct: boolean
  ) {
    if (isClosedByClient) {
      if (state === WaitingListLeadState.Acquired) {
        return <WaitingListLeadStateAcquiredWithClosedDateV1 isPersonalProduct={isPersonalProduct} />;
      }
      return <WaitingListLeadStateClosed isPersonalProduct={isPersonalProduct} />;
    }
    switch (state) {
      case WaitingListLeadState.Open:
        return (
          <WaitingListLeadStateOpenV1
            secureId={secureId || ""}
            isPersonalProduct={isPersonalProduct}
            onSuccessCallback={() => setTimeout(() => showPromotionModal(), 2000)}
          />
        );
      case WaitingListLeadState.Acquired:
        return <WaitingListLeadStateAcquiredV1 isPersonalProduct={isPersonalProduct} />;
      default:
        return <WaitingListLeadStateRejectedV1 />;
    }
  }

  function showPromotionModal() {
    if (!isRegisterForAMSet && !isAuthenticated) {
      setPromotionModal(true);
    }
  }

  const handleEmailSentActivity = (activity: Activity) => {
    setEmailActivities(prev => [activity, ...prev]);
    setActivityLog(prev => [activity, ...prev]);
    setTimeout(() => {
      const simulatedResponse: Activity = {
        icon: "fa-solid fa-reply",
        time: new Date().toLocaleTimeString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }),
        detail: new Date().toLocaleTimeString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }),
        title: "E-Mail von Max Mustermann erhalten",
        text: "E-Mail von Max Mustermann erhalten – Betreff: Re: Bestätigung unseres Termins am 03.02.2026",
      };
      setEmailActivities(prev => [simulatedResponse, ...prev]);
      setActivityLog(prev => [simulatedResponse, ...prev]);
        
      
      // Info-Toast anzeigen, wenn die simulierte E-Mail empfangen wird
      toast.info("Neue E-Mail von Max Mustermann erhalten!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }, 5000);
  };

  const modalOrder = ["call", "email", "note", "task"];
  const gap = 20;
  const startLeft = 50;

  const calculateModalOffsets = () => {
    let currentLeft = startLeft;
    const offsets: { [key: string]: number } = {};

    modalOrder.forEach((modalKey) => {
      let isOpen = false;
      switch (modalKey) {
        case "call":
          isOpen = callModalOpen;
          break;
        case "email":
          isOpen = emailModalOpen;
          break;
        case "note":
          isOpen = noteModalOpen;
          break;
        case "task":
          isOpen = taskModalOpen;
          break;
        default:
          break;
      }
      const width = isOpen ? 500 : 250;
      offsets[modalKey] = currentLeft;
      currentLeft += width + gap;
    });
    return offsets;
  };

  const modalOffsets = calculateModalOffsets();

  return (
    <div className="lead-detail-container">
      <BackToTopButton />
      <div className="detail-layout">
        <div className="sidebar-left">
          {mockData.waitingListLeadDetailsInfo && (
            <>
              <div className="contact-details">
                <div className="contact-info">
                  <div className="contact-info-header">
                    <span onClick={() => navigate("/leadOverview/won")}>
                      <i className="fa-solid fa-arrow-left" /> Zurück
                    </span>
                    <span
                      className="contact-info-header-title"
                      onClick={() => setSourceModalOpen(true)}
                      style={{ cursor: "pointer" }}
                    >
                      Quelle: VP Verbund Pflegehilfe
                    </span>
                  </div>
                  <h2>
                    {mockData.waitingListLeadDetailsInfo.firstName}{" "}
                    {mockData.waitingListLeadDetailsInfo.lastName}
                  </h2>
                  <p>Erreichbar: {mockData.waitingListLeadDetailsInfo.clientAvailability}</p>
                  <p>Interessiert an: Pflegedienst</p>
                </div>
                <div className="action-buttons">
                  <button onClick={() => setCallModalOpen(true)}>
                    <i className="fa-solid fa-phone" />
                  </button>
                  <button onClick={() => setEmailModalOpen(true)}>
                    <i className="fa-solid fa-envelope" />
                  </button>
                  <button onClick={() => setNoteModalOpen(true)}>
                    <i className="fa-solid fa-sticky-note" />
                  </button>
                  <button onClick={() => setTaskModalOpen(true)}>
                    <i className="fa-solid fa-check" />
                  </button>
                </div>
              </div>
              <CollapsibleGroup title="Über Ihren Klienten">
                <ProductDetailCard
                  type="text"
                  title="Klientenname"
                  content={`${mockData.waitingListLeadDetailsInfo.firstName} ${mockData.waitingListLeadDetailsInfo.lastName}`}
                />
                <ProductDetailCard
                  type="editabletext"
                  title="Verfügbarkeit"
                  content={mockData.waitingListLeadDetailsInfo.clientAvailability}
                />
                <ProductDetailCard
                  type="text"
                  title="Bedarfsort"
                  content={mockData.waitingListLeadDetailsInfo.bedarfsort}
                />
                <ProductDetailCard
                  type="text"
                  title="Adresse"
                  content={mockData.waitingListLeadDetailsInfo.addresse}
                />
                <ProductDetailCard
                  type="text"
                  title="Telefonnummer"
                  content={mockData.waitingListLeadDetailsInfo.phoneNumber}
                />
              </CollapsibleGroup>
              <CollapsibleGroup title="Produktkriterien">
                <ProductDetailCard
                  type="text"
                  title="Produktname"
                  content={"Pflegedienst"}
                />
                <ProductDetailCard
                  type="text"
                  title="Region"
                  content={mockData.waitingListLeadDetailsInfo.requestRegion}
                />
                <ProductDetailCard
                  type="text"
                  title="PLZ"
                  content={mockData.waitingListLeadDetailsInfo.requestZipCode}
                />
                {mockData.waitingListLeadDetailsInfo.productCriteriaList &&
                  mockData.waitingListLeadDetailsInfo.productCriteriaList.map((criteria, index) => (
                    <ProductDetailCard
                      type="text"
                      key={index}
                      title={criteria.criteriaName}
                      content={criteria.value}
                    />
                  ))}
              </CollapsibleGroup>
              <CollapsibleGroup title="Über die Quelle">
                <ProductDetailCard
                  type="text"
                  title="VP Verbund Pflegehilfe"
                  content="Der Verbund Pflegehilfe unterstützt als größte Pflegeberatung Deutschlands Pflegebedürftige, Angehörige und pflegende Angehörige. Seit der Gründung im Jahr 2008 wurden bereits über 1,5 Millionen Beratungsgespräche geführt."
                />
              </CollapsibleGroup>
            </>
          )}
        </div>
        <div className="main-content">
          <div className="main-content-header">
            <div className="main-content-header-box"
              onClick={() => navigate("/waiting-list-lead-details/erika")}

            >
              <i className="fa-solid fa-arrow-left"
              />
              Vorheriger
            </div>
            <h1 className="detail-number">
              Anfrage: {mockData.waitingListLeadDetailsInfo.waitingListLeadNumber}
            </h1>
            <div className="main-content-header-box"
              onClick={() => navigate("/waiting-list-lead-details/erika")}

            >
              Nächster
              <i className="fa-solid fa-arrow-right"

              />
            </div>
          </div>

          <MiddleSection
            getWaitingListLeadStatusView={getWaitingListLeadStatusView}
            contactInfo={{
              firstName: mockData.waitingListLeadDetailsInfo.firstName,
              lastName: mockData.waitingListLeadDetailsInfo.lastName,
              clientAvailability: mockData.waitingListLeadDetailsInfo.clientAvailability,
              phoneNumbers: mockData.waitingListLeadDetailsInfo.phoneNumbers,
              email: "max.mustermann@gmail.com"
            }}
            activityLog={activityLog}
            emailActivities={emailActivities}
            noteActivities={noteActivities}
            callActivities={callActivities}
            taskActivities={taskActivities}
            mockData={mockData}
            selectedEmail={selectedEmail}
            setSelectedEmail={setSelectedEmail}
          />
        </div>
        <div className="sidebar-right">
          <GroupSection title="Angehörige" items={mockData.relativeItems} />
          <GroupSection title="Anfragen" items={mockData.productItems} />
          {emailActivities.length > 0 && (
            <GroupSection title="Gesendete E‑Mails" items={emailActivities}
              action={() => setSelectedEmail(true)}

            />
          )}
          <GroupSection
            title="Aufgaben"
            items={taskActivities.length > 0 ? taskActivities : [{ text: "Noch keine Aufgaben vorhanden" }]}
            action={() => navigate("/task-management")}
          />
          
   
          
          <GroupSection
            title="Anrufe"
            items={callActivities.length > 0 ? callActivities : [{ text: "Noch keine Anrufe vorhanden" }]}
          />

        </div>
      </div>
      <CallModal
        open={callModalOpen}
        onClose={() => setCallModalOpen(false)}
        onOpen={() => setCallModalOpen(true)}
        leftOffset={modalOffsets.call}
        onCallAdded={(activity) => {
          setCallActivities(prev => [activity, ...prev]);
          setActivityLog(prev => [activity, ...prev]);
        }}
      />
      <EmailModal
        open={emailModalOpen}
        onClose={() => setEmailModalOpen(false)}
        leftOffset={modalOffsets.email}
        onEmailSent={handleEmailSentActivity}
        onOpen={() => setEmailModalOpen(true)}
      />
      <TaskModal
        open={taskModalOpen}
        onClose={() => setTaskModalOpen(false)}
        onOpen={() => setTaskModalOpen(true)}
        leftOffset={modalOffsets.note}
        onTaskAdded={(activity) => {
          setTaskActivities(prev => [activity, ...prev]);
          setActivityLog(prev => [activity, ...prev]);
        }}
      />
      <SourceModal
        open={sourceModalOpen}
        onClose={() => setSourceModalOpen(false)}
      />
    </div>
  );
}

export default WaitingListLeadOverviewV1;
